<template>
	<div
			id="services-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<!--<img src='../assets/img/c1.jpg' alt="">-->
		<swiper :options="swiperOption" ref="mySwiper5">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/c1.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Pricing') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div class="page">
			<h1 class="page__title">{{ $t('Valuation_pricing') }} - {{ $t('VAT_not_included') }}</h1>
			<hr class="page__hr">

			<div class="page__container main">

				<div class="page__content left">
					{{ $t('Pricing_text_01') }}.


				</div>

				<div class="page__content right" style="background-color: whitesmoke; padding: 1rem;">
					<router-link :to="{ name: 'quote-request'}"><span style="color: black;"><strong>{{ $t('Request_a_quote_here') }}</strong></span>
						. {{ $t('Pricing_text_02') }}.
					</router-link>

				</div>
			</div>

			<h3 style="color: midnightblue">{{ $t('Dwellings') }}, {{ $t('Parking_spaces') }} {{ $t('and') }} {{ $t('Storerooms') }}</h3>

			<table class="d-table-center">
				<thead>
				<tr>
					<th>{{ $t('Appraisal_value') }} {{ $t('in_01') }} {{ $t('thousands_of_euros') }}</th>
					<th>{{ $t('Mortgage_Appraisal_Fees') }} *<sup>1</sup> *<sup>2</sup></th>
					<th>{{ $t('Informative_Appraisal_Fees') }}  *<sup>2</sup></th>

				</tr>
				</thead>
				<tbody>
				<tr v-for="(range, key, index) in valuation_prices.group_A" v-if="index < 6">
					<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}</td>
					<td> {{ range.mortgage_valuation_fee }} €
						<span
							class="small"
							v-if="range.increment_pct_mortgage_valuation > 0">
						+ {{ range.increment_pct_mortgage_valuation }} % {{ $t('of_the_excess_of') }} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
					</td>
					<td>{{ range.standard_valuation_fee }} €
						<span
							class="small"
							v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of') }} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
					</td>
				</tr>
				<tr>
					<td> {{ $t('Higher_values') }}</td>
					<td> {{ $t('acc_Budget') }}</td>
					<td> {{ $t('acc_Budget') }}</td>
				</tr>
				</tbody>
			</table>

			<h3 style="color: midnightblue">{{ $t('Commercial_premises') }}, {{ $t('Offices') }} {{ $t('and') }} {{ $t('Industrial_warehouses') }}</h3>

			<table class="d-table-center">
				<thead>
				<tr>
					<th>{{ $t('Appraisal_value') }} {{ $t('in_01') }} {{ $t('thousands_of_euros') }}</th>
					<th>{{ $t('Mortgage_Appraisal_Fees') }} *<sup>1</sup> *<sup>2</sup></th>
					<th>{{ $t('Informative_Appraisal_Fees') }}  *<sup>2</sup></th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(range, key, index) in valuation_prices.group_B" v-if="index < 5">
					<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}</td>
					<td> {{ range.mortgage_valuation_fee }} €
						<span
							class="small"
							v-if="range.increment_pct_mortgage_valuation > 0">
						+ {{ range.increment_pct_mortgage_valuation }} % {{ $t('of_the_excess_of') }} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
					</td>
					<td>{{ range.standard_valuation_fee }} €
						<span
							class="small"
							v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of') }} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
					</td>
				</tr>
				<tr>
					<td> {{ $t('Higher_values') }}</td>
					<td> {{ $t('acc_Budget') }}</td>
					<td> {{ $t('acc_Budget') }}</td>
				</tr>
				</tbody>
			</table>

			<h3 style="color: midnightblue">
				{{ $t('Buildings') }}, {{ $t('Property_developments') }}, {{ $t('Properties_under_economic_exploitation') }} {{ $t('and') }} {{ $t('Land_pl') }}</h3>

			<table class="d-table-center">
				<thead>
				<tr>
					<th>{{ $t('Appraisal_value') }} {{ $t('in_01') }} {{ $t('thousands_of_euros') }}</th>
					<th>{{ $t('Fees') }} *<sup>2</sup></th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(range, key, index) in valuation_prices.group_C" v-if="index < 6">
					<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}</td>
					<td>{{ range.standard_valuation_fee }} €
						<span
							class="small"
							v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of') }} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
					</td>
				</tr>
				<tr>
					<td> {{ $t('Higher_values') }}</td>
					<td> {{ $t('acc_Budget') }}</td>
				</tr>
				</tbody>
			</table>

			<h3 style="color: midnightblue">{{ $t('Machinery') }}, {{ $t('Expropriations') }} {{ $t('and') }} {{ $t('others') }}: <span
					style="color: gray">{{ $t('acc_Budget') }}</span></h3>


			<br>
			<strong>
				*<sup></sup> {{ $t('Pricing_text_03') }}.

			<br>
				*<sup>1</sup> {{ $t('Pricing_text_04') }}.
			<br>
				*<sup>2</sup> {{ $t('Pricing_text_05') }}.
			</strong>

			<br>

			<h1 class="page__title">{{ $t('Report_content') }}</h1>
			<hr class="page__hr">

			<div class="page__container main">

					<ul>
						<li>
							{{ $t('Report_content_text_01') }}.
						</li>
						<li>
							{{ $t('Report_content_text_02') }}.
						</li>
						<li>
							{{ $t('Report_content_text_03') }}.
						</li>
						<li>
							{{ $t('Report_content_text_04') }}.
						</li>
					</ul>

			</div>

		</div>


		<div class="page" style="background: whitesmoke">
			<h1 class="page__title">{{ $t('Other_services') }}</h1>
			<hr class="page__hr">

			<h3 style="color: midnightblue">{{ $t('Energy_Efficiency_Certificate') }}: <span
					style="color: gray">{{ $t('EEC_conditions') }}. {{ $t('OT_conditions') }}.</span></h3>


			<h3 style="color: midnightblue">{{ $t('Occupancy_Card_and_Certificate') }}: <span
					style="color: gray">{{ $t('OCC_conditions') }}. {{ $t('OT_conditions') }}.</span></h3>

			<h3 style="color: midnightblue">
				{{ $t('Energy_Efficiency_Certificate') }} {{ $t('and') }} {{ $t('Occupancy_Card') }} {{ $t('of_the_same_property') }}: <span
					style="color: gray">{{ $t('EECOCC_conditions') }}. {{ $t('OT_conditions') }}.</span></h3>

			<h3 style="color: midnightblue">{{ $t('Surveying') }} {{ $t('and') }} {{ $t('Measurements') }}: <span
					style="color: gray">{{ $t('acc_Budget') }}</span></h3>

		</div>

		<div class="page">
			<strong>
				*<sup>3</sup> {{ $t('Pricing_text_06') }}.
			</strong>
		</div>
	<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Message from '../components/Message.vue'
    import FooterBar from '../components/FooterBar.vue'
    import LogoBar from '../components/LogoBar.vue'
    import NavBar from '../components/NavBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'pricing',

        mixins: [localStorageMixin],

        components: {
            Message,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({
            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),

        created () {
            this.FETCH_VALUATION_PRICES()
                .then(() => {
                    this.loading = false
                })
        },

        computed: {
            ...mapGetters(['user',
                'theme',
                'valuation_prices'
            ])
        },

        methods: {
            ...mapActions(['LOG_IN_USER',
                'FETCH_VALUATION_PRICES'
            ]),
            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Services'
            }
        }

    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// Pricing.vue?ba94ba12